
import request from '@/utils/request'

export function getListProductUnitApi(query) {
  return request({
    url: '/config-service/v1/product-cal-unit/list',
    method: 'get',
    params: query
  })
}

export function addProductUnitApi(query) {
  return request({
    url: '/config-service/v1/product-cal-unit',
    method: 'post',
    data: query
  })
}

export function updateProductUnitApi(query) {
  return request({
    url: '/config-service/v1/product-cal-unit',
    method: 'put',
    data: query
  })
}

export function deleteProductUnitApi(query) {
  return request({
    url: '/config-service/v1/product-cal-unit',
    method: 'delete',
    data: query
  })
}
